import { useEffect, useState } from "react";
import { api } from "./api";

// Shared frontend sales-tax source. Every commerce surface
// (Review & Submit screens, Checkout) reads the rate + label
// from a single call to /api/settings so we cannot drift.
//
// Backend `core/tax.py` remains the pricing authority — server
// re-validates on order submit. This hook is display-only.
//
// Rounding contract: 2dp on tax + total, mirroring backend
// `apply_sales_tax` (see /app/backend/core/tax.py).
export const roundMoney = (n) => Math.round(Number(n || 0) * 100) / 100;

export const computeTaxBreakdown = (subtotal, taxRate) => {
  const sub = roundMoney(subtotal);
  const rate = Number(taxRate) || 0;
  const tax = roundMoney(sub * rate);
  const total = roundMoney(sub + tax);
  return { subtotal: sub, taxAmount: tax, total };
};

export function useSalesTax() {
  const [taxRate, setTaxRate] = useState(0);
  const [taxLabel, setTaxLabel] = useState("Tax");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => {
        if (typeof r.data?.sales_tax_rate === "number") setTaxRate(r.data.sales_tax_rate);
        if (typeof r.data?.sales_tax_label === "string") setTaxLabel(r.data.sales_tax_label);
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const compute = (subtotal) => computeTaxBreakdown(subtotal, taxRate);

  return { taxRate, taxLabel, loaded, compute };
}
